/* ============================================================
   ap-motion.js — 新首頁九屏 共用動效(2026-08-19 rev2)
   M0 進場 / 跑馬燈(自動補組無縫) / 輪播圓點 / S1 捲動亮屏 /
   S5 cowboy式兩段(sticky拼合→步驟區隨捲動依序亮) / S8 逐字實體化(提速)
   鐵則:passive listener、rAF 節流、零觸控攔截、reduced-motion 全退避。
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero 影片延後載入（WO-0903-5，2026-09-02）：poster 先當 LCP，window load 後才掛 src ----------
     位置刻意放在 reduce 早退之前（舊版放在檔尾，開了「減少動態」的手機會被早退跳過而抓到 2.2MB 桌機檔）。
     規則：reduce 或 Save-Data → 只留 poster、不載影片；手機(<735) 掛 720p，桌機掛 1080p；畫質不降。 */
  (function () {
    var vids = document.querySelectorAll('[data-ap-video][data-src]');
    if (!vids.length) return;
    var conn = navigator.connection || {};
    if (reduce || conn.saveData) return;
    var mobile = window.innerWidth < 735;
    function attach() {
      vids.forEach(function (v) {
        if (v.getAttribute('src')) return;
        v.setAttribute('src', mobile && v.dataset.srcMobile ? v.dataset.srcMobile : v.dataset.src);
        v.load();
        var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
      });
    }
    if (document.readyState === 'complete') { setTimeout(attach, 0); }
    else { window.addEventListener('load', function () { setTimeout(attach, 0); }, { once: true }); }
  })();


  /* ---------- M0 進場(IO 一次性) ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('on');
      io.unobserve(e.target);
    });
  }, { threshold: 0.3 });
  /* 2026-08-31 Jack実機回報:手機輪播(.ap-car)の次卡peekが初載で透明。病因=IOの交集矩形は
     祖先(輪播容器)のoverflowでclipされ、次卡は可視24px≒7%でthreshold 0.3に永遠に届かない
     (rootMargin拡張はviewportのみでclip矩形に無効=実測で確認)。
     正解=手機輪播内の首卡以外はreveal対象外(即顕):滑動は用戶主動=内容即現が正・peek常時可視。
     首卡は従来IO=區塊進場の動効維持。桌機(grid化)は逐卡delay設計を不変。 */
  var apMobileCar = window.matchMedia('(max-width: 734px)').matches;
  document.querySelectorAll('.ap-rv').forEach(function (el) {
    if (reduce) { el.classList.add('on'); return; }
    /* appr__rail(約束shelf)=全斷點で橫滑=非首卡は常に即顕 */
    var rail = el.closest('[data-appr-rail]');
    if (rail && rail.querySelector('.ap-rv') !== el) { el.classList.add('on'); return; }
    var car = el.closest('.ap-car');
    if (apMobileCar && car && car.querySelector('.ap-rv') !== el) { el.classList.add('on'); return; }
    io.observe(el);
  });

  /* ---------- 跑馬燈:自動複製到 ≥2×視窗寬(偶數組=無縫) ---------- */
  document.querySelectorAll('.ap-mq__track').forEach(function (t) {
    if (reduce) return;
    var base = t.innerHTML, guard = 0;
    t.innerHTML = base + base;
    while (t.scrollWidth < window.innerWidth * 2 && guard < 4) {
      t.innerHTML += t.innerHTML; guard++;
    }
  });

  /* ---------- 輪播引擎v4(2026-09-01 Jack拍板:1-2-3-1-2-3無限向右循環) ----------
     v3(實績帶移植)から改版:3s/張・無縫向右循環=複製一組卡接尾→滑進複製組の
     「動畫終了瞬間」に像素等同の靜默瞬移で本尊へ(Swiper loop mode同手法;
     旧「次拍で跳回」は複製卡上に留まる窓口がありiOSで逆走化)・前進=rAF自算
     tween(ease-out 450ms;iOSのsnap容器×smooth捲動不安定を回避)・手滑=原生
     scroll-snap不接管+tween即中断・視窗外/背景分頁停・reduced-motion不自動。
     桌機grid=[data-ap-clone]をCSSで非表示+tick no-op。圓點=最近接卡index % n */
  document.querySelectorAll('.ap-car').forEach(function (car) {
    var real = Array.prototype.slice.call(car.children);
    if (real.length < 2) return;
    var dotsWrap = car.parentElement.querySelector('.ap-dots');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('i') : [];
    /* data-ap-car-static(2026-09-01 Jack:技術頁は自動輪播取消)=複製・自動播なし,手滑+圓點のみ */
    var isStatic = car.hasAttribute('data-ap-car-static');
    if (!isStatic) real.forEach(function (c) {
      var k = c.cloneNode(true);
      k.setAttribute('aria-hidden', 'true');
      k.setAttribute('data-ap-clone', '1');
      k.removeAttribute('data-appg-reveal');
      k.classList.add('on', 'is-in');
      k.style.transitionDelay = '0ms';
      k.querySelectorAll('.ap-rv, [data-appg-reveal]').forEach(function (m) {
        m.classList.add('on', 'is-in'); m.removeAttribute('data-appg-reveal'); m.style.transitionDelay = '0ms';
      });
      car.appendChild(k);
    });
    var all = Array.prototype.slice.call(car.children);
    var n = real.length;
    var idx = 0, timer = null;
    function nearestIdx() {
      var center = car.scrollLeft + car.clientWidth / 2, best = 0, bd = 1e9;
      all.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function syncDots() {
      idx = nearestIdx();
      dots.forEach(function (d, i) { d.classList.toggle('on', i === idx % n); });
    }
    car.addEventListener('scroll', function () { requestAnimationFrame(syncDots); }, { passive: true });
    if (isStatic) { syncDots(); return; } /* 靜態車=ここまで(自動播機構は組まない) */
    /* ---- 2026-09-01 wrap倒退の根治(Jack回報:iOS実機で3→1後の1→2が逆走) ----
       標準手法=Swiper loop mode同款:複製組へ滑り込んだ「動畫終了の瞬間」に
       像素等同の靜默瞬移で本尊へ戻す(次拍まで複製卡上に留まる窓口を消す)。
       前進動畫=原生smooth scrollTo廃止→rAF自算tween(ease-out cubic 450ms)。
       理由:iOS Safariはscroll-snap容器への程式化smooth捲動が不安定=逆走・
       合併の温床(skills: transform/scroll系はJS駆動で決定論化・interruptible)。 */
    var anim = null;
    function cancelAnim() {
      if (anim) { cancelAnimationFrame(anim); anim = null; }
      car.style.scrollSnapType = ''; /* tween終了/中断=snap即復帰(手滑吸附は常時有効) */
    }
    /* 手滑・滾輪開始=tween即中断(interruptible:使用者入力優先) */
    ['touchstart', 'wheel', 'pointerdown'].forEach(function (ev) {
      car.addEventListener(ev, cancelAnim, { passive: true });
    });
    function glide(target, done) {
      cancelAnim();
      var from = car.scrollLeft, dist = target - from, t0 = null, DUR = 450;
      if (Math.abs(dist) < 1) { done && done(); return; }
      /* snap mandatoryはJS逐幀書込を吸附点へ量化=瞬間跳びの病因→動畫中のみ無効化
         (GSAP scrollTo系/Swiperの標準対処;終了・中断でcancelAnim経由復帰) */
      car.style.scrollSnapType = 'none';
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / DUR);
        var e = 1 - Math.pow(1 - p, 3); /* ease-out cubic */
        car.scrollLeft = from + dist * e;
        if (p < 1) { anim = requestAnimationFrame(frame); }
        else { anim = null; car.style.scrollSnapType = ''; done && done(); }
      }
      anim = requestAnimationFrame(frame);
    }
    function settleToReal() {
      /* 複製組上に居るなら像素等同の靜默瞬移で本尊へ(對応卡同士の直接距離) */
      var cur = nearestIdx();
      if (cur >= n) {
        car.scrollLeft = car.scrollLeft - (all[cur].offsetLeft - all[cur - n].offsetLeft);
      }
    }
    function tick() {
      if (getComputedStyle(car).overflowX === 'visible') return; /* 桌機grid=no-op */
      if (anim) return; /* 前拍のtween未了=スキップ(重複駆動防止) */
      var step = all[1].offsetLeft - all[0].offsetLeft;
      if (step < 1) return;
      settleToReal(); /* 保險:手滑で複製組に入ったまま等の残留状態を先に正規化 */
      glide(car.scrollLeft + step, settleToReal);
    }
    function start() { if (reduce || timer) return; timer = setInterval(tick, 3000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var inView = false;
    function sync() { if (inView && !document.hidden) start(); else stop(); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inView = e.isIntersecting; sync(); });
      }, { threshold: 0.35 }).observe(car);
    } else { inView = true; sync(); }
    document.addEventListener('visibilitychange', sync);
    syncDots();
  });

  /* ---------- scroll-linked 目標 ---------- */
  /* 2026-08-27 拆sticky(Jack拍板投影片式流):S5=標題/影片/why/步驟各一屏普通捲動;
     實體化/點亮改隨各元素自身視口位置驅動(同S8);舊sticky四幕=git f04288b 版 */
  var heroImg = document.querySelector('[data-ap-lit] .aph__media img, [data-ap-lit] .aph__media video');
  var whyBlock = document.querySelector('[data-ap-tech-why]');
  var stepsBlock = document.querySelector('[data-ap-tech-steps]');
  var steps = stepsBlock ? Array.prototype.slice.call(stepsBlock.querySelectorAll('[data-ap-step]')) : [];

  /* 逐字拆分(共用:S5 標題 + S8 哲学句) */
  function splitChars(el) {
    if (!el) return [];
    var txt = el.textContent;
    el.textContent = '';
    Array.prototype.forEach.call(txt, function (c) {
      var sp = document.createElement('span');
      sp.textContent = c;
      el.appendChild(sp);
    });
    return Array.prototype.slice.call(el.children);
  }
  var techTitle = document.querySelector('[data-ap-tech-title]');
  var titleChars = splitChars(techTitle);
  var phi = document.querySelector('[data-ap-phi]');
  var phiChars = splitChars(phi);
  var brandSec = document.querySelector('[data-ap-brand]');

  /* why 拆字(2026-08-27):保留 <br> 斷行;aria-label 留原文、span aria-hidden */
  function splitCharsBr(el) {
    if (!el) return [];
    el.setAttribute('aria-label', el.textContent);
    var out = [];
    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(node.textContent, function (c) {
          var sp = document.createElement('span');
          sp.textContent = c;
          sp.setAttribute('aria-hidden', 'true');
          frag.appendChild(sp);
          out.push(sp);
        });
        el.replaceChild(frag, node);
      }
    });
    return out;
  }
  var whyChars = whyBlock
    ? splitCharsBr(whyBlock.querySelector('.apte__why-head-text')).concat(splitCharsBr(whyBlock.querySelector('.apte__why-body')))
    : [];
  /* 步驟卡=光掃遮罩制(2026-08-28 v2):拆字退役,亮態覆層由 --li 垂直揭開(字被光掃過) */

  if (reduce) {
    if (heroImg) heroImg.style.filter = 'brightness(1)';
    steps.forEach(function (s) { s.style.setProperty('--li', '1'); });
    titleChars.forEach(function (c) { c.classList.add('lit'); });
    whyChars.forEach(function (c) { c.classList.add('lit'); });
    phiChars.forEach(function (c) { c.classList.add('lit'); });
    if (brandSec) brandSec.classList.add('done');
    return;
  }

  var ticking = false;
  function clamp01(v) { return Math.min(1, Math.max(0, v)); }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;

      /* S1 亮屏=捲動驅動:前 55vh 的捲動把 brightness .25→1(亮起後不回頭) */
      if (heroImg) {
        var ph = clamp01(window.scrollY / (vh * 0.55));
        if (!heroImg._apMax || ph > heroImg._apMax) heroImg._apMax = ph;
        heroImg.style.filter = 'brightness(' + (0.25 + 0.75 * heroImg._apMax).toFixed(3) + ')';
      }

      /* S5 釘住三幕(2026-08-28 Jack拍板):動畫幕 sticky 卡住,進度=釘住行程內的捲動量
         (p=-wrapper.top/(wrapper高-vh));0–0.85 跑完動畫,尾段停格再放行。倒滑反向。 */
      function pinP(name) {
        var w = document.querySelector('[data-ap-pin="' + name + '"]');
        if (!w) return -1;
        var rr = w.getBoundingClientRect();
        /* B3:舞台sticky top=9svh、行程=wrapper高-舞台高;p=(offset-top)/行程 */
        var beat = w.firstElementChild;
        var total = rr.height - (beat ? beat.offsetHeight : vh);
        if (total <= 0) return clamp01((vh * 0.85 - rr.top) / (vh * 0.5));
        return clamp01((vh * 0.09 - rr.top) / total);
      }
      if (techTitle) {
        var pT = pinP('title');
        if (pT >= 0) {
          var litT = Math.floor(clamp01(pT / 0.85) * titleChars.length);
          titleChars.forEach(function (c, i) { c.classList.toggle('lit', i < litT); });
        }
      }
      if (whyBlock && whyChars.length) {
        var pW = pinP('why');
        if (pW >= 0) {
          var litW = Math.floor(clamp01(pW / 0.85) * whyChars.length);
          whyChars.forEach(function (c, i) { c.classList.toggle('lit', i < litW); });
        }
      }
      /* 步驟=光從卡頂往下掃(2026-08-28 v2):pn 0→1 內三卡依序(li_i=pn*3-i),
         --li 驅動亮態覆層垂直遮罩往下揭開;倒滑天然反向 */
      if (stepsBlock) {
        var pS = pinP('steps');
        if (pS >= 0) {
          var pn = clamp01(pS / 0.85);
          steps.forEach(function (s, i) {
            s.style.setProperty('--li', clamp01(pn * 3 - i).toFixed(3));
          });
        }
      }

      /* S8 逐字實體化(提速):進入視野後前 40% 捲動內全亮;80% 出品牌句 */
      if (phi && brandSec) {
        var r8 = brandSec.getBoundingClientRect();
        var p8 = clamp01((vh * 0.85 - r8.top) / (vh * 0.5));
        var lit = Math.floor(p8 * phiChars.length);
        phiChars.forEach(function (c, i) { c.classList.toggle('lit', i < lit); });
        brandSec.classList.toggle('done', p8 >= 0.72);
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  /* header 捲動隱藏（cowboy 式）は WO-1007-s7-9（2026-10-07）で退役＝Horizon 原生 enable_sticky_header: scroll-up に統一（sections/header-group.json） */

})();
